import withApollo from "next-with-apollo";
import getConfig from "next/config";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { ApolloLink } from "apollo-link";
import { setContext } from "apollo-link-context";
import { createUploadLink } from "apollo-upload-client";
import getAuthorization from "../src/helpers/getAuthorization";
import { removeAuthorization } from "../src/helpers/removeAuthorization";
import { isServer } from "../src/helpers/isServer";
import { onError } from "apollo-link-error";

import fetch from "isomorphic-unfetch";

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

export const getGqlUrl = headers => {
  if (isServer) {
    return serverRuntimeConfig.API_URL;
  } else {
    return publicRuntimeConfig.API_URL;
  }
};

const errorLink = ctx =>
  onError(({ graphQLErrors, operation, forward, response }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        switch (err.extensions.code) {
          case "UNAUTHENTICATED":
            removeAuthorization(ctx);
        }
      }
    }
  });

const authLink = ctx =>
  setContext((_, { headers }) => {
    const { token } = getAuthorization(ctx);

    return {
      headers: {
        ...headers,
        authorization: token && `Bearer ${token}`
      }
    };
  });

const getUploadLink = headers =>
  createUploadLink({
    uri: getGqlUrl(headers),
    credentials: "same-origin",
    headers: {
      ...headers,
      "apollo-require-preflight": "true"
    },
    fetch: !process.browser && fetch
  });

export default withApollo(({ ctx, headers, initialState }) => {
  return new ApolloClient({
    ssrMode: typeof window === "undefined",
    link: ApolloLink.from([
      errorLink(ctx),
      authLink(ctx),
      getUploadLink(headers)
    ]),
    cache: new InMemoryCache().restore(initialState || {})
  });
});
